import createModel, { arbitraryKeys, Silent } from "@/__main__/data-model.mjs";

const Items = Silent({
  apiKey: Silent(String),
  name: String,
  description: Silent(String),
  buildsInto: Silent([String]),
  buildsFrom: Silent([String]),
  depth: Silent(Number),
  kind: Silent(String),
  trait: Silent(String),
});

const apiModelValidation = createModel({
  [arbitraryKeys]: Items,
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;
